module.exports = __webpack_public_path__ + "img/send-sel-audio.937d5b06.svg";